module.exports = __webpack_public_path__ + "media/images/turbochargers/turbo2-cc37cbb02ee7d3ba6ff143d2f3eaa6a0.png";